import contacts from './contacts';
import tags from './tags';

export default function* (){
    yield* [...contacts];
    yield* [...tags];
}